export default __webpack_public_path__ + "static/media/group-option-male-unselected.53df2041.svg";